import { render, staticRenderFns } from "./ResourceRequests.vue?vue&type=template&id=536d3b00&"
import script from "./ResourceRequests.vue?vue&type=script&lang=js&"
export * from "./ResourceRequests.vue?vue&type=script&lang=js&"
import style0 from "./ResourceRequests.vue?vue&type=style&index=0&id=536d3b00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports